import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const AutocompleteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18", height: "18", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g id="chevron-down">
        <path
          id="Icon"
          d="M4.5 6.75L9 11.25L13.5 6.75"
          stroke="#414141"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export default AutocompleteIcon;
